// @ts-nocheck
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import * as React from 'react';
import type { DropdownItem } from 'commons/types';
import type { FormInputEvent } from 'utils/form/Form.types';
import Icon from 'components/uielements/Icon';
import DropdownWrapper from './Dropdown.style';
import type { DropdownProps, DropdownState } from './Dropdown.types';

class Dropdown extends React.Component<DropdownProps, DropdownState> {
  constructor(props: DropdownProps) {
    super(props);
    const { value: data = {}, placeholder = '—Select option—' } = props;
    this.state = {
      isOpen: false,
      selectedValue: data.value
        ? data
        : {
            label: placeholder,
          },
    };
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  onToggleOpen = (disabled: boolean | null | undefined) => () => {
    if (!disabled) {
      const { isOpen } = this.state;
      this.setState({
        isOpen: !isOpen,
      });
    }
  };

  onToggleSelected = (item: DropdownItem) => () => {
    const { onChange, name } = this.props;
    this.setState({
      isOpen: false,
      selectedValue: item,
    });
    onChange(this.createEvent(name, item));
  };

  setDropdownRef = (node: any): void => {
    this.dropdownRef = node;
  };

  dropdownRef: any;

  handleClickOutside = ({ target }: MouseEvent): void => {
    if (this.dropdownRef && !this.dropdownRef.contains(target)) {
      this.setState({
        isOpen: false,
      });
    }
  };

  handleOnKeyDown = (e: KeyboardEvent): void => {
    const keycode = e.keyCode ? e.keyCode : e.which;

    if (keycode === 40 || keycode === 38) {
      e.preventDefault();
      const { selectedValue } = this.state;
      const { options: list = [], onChange, name } = this.props;
      const currentIndex = list.findIndex((item) => item.value === selectedValue.value);
      const indexModifier = this.calculateIndexModifier(keycode);
      const nextIndex = this.calculateNextItemIndex(currentIndex, indexModifier, list.length);
      const nextItem = list[nextIndex];
      this.setState({
        selectedValue: nextItem,
      });
      onChange(this.createEvent(name, nextItem));
    }
  };

  calculateIndexModifier = (keycode: number): number => {
    let indexModifier = 0;

    if (keycode === 40) {
      indexModifier = 1;
    } else if (keycode === 38) {
      indexModifier = -1;
    }

    return indexModifier;
  };

  calculateNextItemIndex = (
    currentIndex: number,
    indexModifier: number,
    listLength: number,
  ): number => {
    const indexSum = currentIndex + indexModifier;
    return indexSum >= 0 && indexSum < listLength ? indexSum : currentIndex;
  };

  createEvent = (name: string, item: DropdownItem): FormInputEvent => ({
    currentTarget: {
      name,
      value: item,
    },
  });

  renderIcon = (icon?: string): React.ReactElement<any> | null =>
    icon ? <i className={`dropdown__list__item__icon ${icon}`} /> : null;

  renderItem = (item: DropdownItem): React.ReactElement<any> => {
    const { selectedValue } = this.state;
    const { label, value, icon } = item;
    const selectedClass = value === selectedValue.value ? 'dropdown__selected' : '';
    return (
      <li
        className={`dropdown__list__item ${selectedClass}`}
        key={value}
        value={value}
        onClick={this.onToggleSelected(item)}
        onKeyPress={this.onToggleSelected(item)}
      >
        <span>
          {this.renderIcon(icon)}
          {label}
        </span>
      </li>
    );
  };

  renderList = (isOpen: boolean, list: DropdownItem[]): React.ReactElement<any> | null =>
    isOpen ? (
      <div className='dropdown__list'>
        <hr />
        <ul>{list.map((item) => this.renderItem(item))}</ul>
      </div>
    ) : null;

  render() {
    const {
      children,
      disabled,
      headerClass = '',
      isTouched,
      isValid = true,
      options: list = [],
      titleClass = '',
    } = this.props;
    const {
      isOpen,
      selectedValue: { label, value, icon },
    } = this.state;
    const optionSelectedClass = !value ? 'text-option-label' : '';
    const borderClass = isTouched && value ? 'dropdown__touched' : '';
    const disabledClass = disabled ? 'disabled' : '';
    const invalid = !isValid ? '--invalid' : '';
    let arrow = 'down';
    let open = '';

    if (isOpen) {
      arrow = 'up';
      open = '--open';
    }

    return (
      <DropdownWrapper>
        <div className='dropdown__container text-content-body' ref={this.setDropdownRef}>
          <div
            className={`dropdown__header${open}${invalid} ${optionSelectedClass} ${borderClass} ${headerClass} ${disabledClass}`}
            onClick={this.onToggleOpen(disabled)}
            onKeyDown={this.handleOnKeyDown}
            onKeyPress={this.onToggleOpen}
            role='button'
            tabIndex={0}
          >
            {children}
            <span className={`dropdown__header__title ${titleClass}`}>
              {this.renderIcon(icon)}
              {label}
            </span>
            <Icon icon={`icon-arrow_${arrow}`} />
          </div>
          {this.renderList(isOpen, list)}
        </div>
      </DropdownWrapper>
    );
  }
}

export default Dropdown;
